import gql from 'graphql-tag';

export const PubBoxDetails = gql`
  fragment PubBoxDetails on IPubBox {
    ... on IRecord {
      id
    }
    ... on IPubBox {
      box
      jersey_number
      is_organization_jersey
    }
  }
`;
